import * as types from './mutation-types';

export default {
  [types.SET_CLIENT](state, payload) {
    state.client = payload;
  },
  [types.SET_ADMIN_PASSWORD_IS_VALID](state, payload) {
    state.adminPasswordIsValid = payload;
  },
  [types.SET_MODAL_ADMIN_PASSWORD](state) {
    state.modalAdminPassword = !state.modalAdminPassword;
  },
  [types.SET_USERS_CLIENT](state, payload) {
    state.usersClient = payload;
  },
  [types.SET_CURRENT_USER](state, payload) {
    state.currentUser = payload;
  },
};
